import styled from "styled-components"
import { Form } from "@unform/web"

export const Container = styled.div`
  display: flex;
  flex-direction: column;

  height: 100vh;
  width: 100vw;
  overflow: hidden;
`

export const Main = styled.main`
  flex: 1;
  display: grid;
  grid-template-columns: auto 1fr;

  height: 100%;
  min-height: 0;
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;

  height: 100%;
  min-height: 0;

  padding: 15px;
  overflow: hidden;

  h1 {
    margin-bottom: 10px;
  }

  @media (max-width: 768px) {
    h1 {
      font-size: 22px;
    }
  }
`

export const GroupBox = styled.div`
  flex: 1;
  min-height: 0;

  display: flex;
  flex-direction: column;

  border-radius: 10px;
  border: 2px solid ${(props) => props.theme.colors.text};
`

export const TabsContainer = styled.div`
  border-bottom: 2px solid ${(props) => props.theme.colors.secondaryBlue};

  button:first-child {
    border-right: 2px solid ${(props) => props.theme.colors.secondaryBlue};
  }

  button:nth-child(2) {
    border-right: 2px solid ${(props) => props.theme.colors.secondaryBlue};
  }
`

export const TabButton = styled.button<{ isActive: boolean }>`
  height: 40px;
  width: 33.33%;
  position: relative;

  background: none;
  border: none;

  font-size: 1.4rem;
  font-weight: 500;
  color: ${(props) =>
    props.isActive
      ? props.theme.colors.contrastOrange
      : props.theme.colors.text};

  @media (max-width: 768px) {
    font-size: 1.2rem;
  }

  &::after {
    content: "";
    position: absolute;
    bottom: -2px;
    left: 50%;
    transform: translateX(-50%);
    width: 33.33%;
    border-bottom: ${(props) =>
      props.isActive ? `2px solid ${props.theme.colors.contrastOrange}` : ""};
  }
`

export const SmallButton = styled.button`
  height: 56px;
  width: 56px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 8px;
  background-color: #1fa643;

  &.search {
    background-color: ${(props) => props.theme.colors.primaryBlue};
  }

  svg {
    width: 30px;
    height: 30px;

    stroke-width: 3px;

    color: white;
  }

  @media (max-width: 768px) {
    width: auto;
    height: 28px;

    svg {
      width: 20px;
      height: 20px;
    }
  }

  &:hover {
    background: ${(props) => props.theme.colors.secondaryBlue};
  }
`

export const StyledForm = styled(Form)`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;

  overflow: hidden;
  margin: 15px;
  gap: 10px;
`

export const ButtonsContainer = styled.span`
  display: flex;
  flex-direction: row;

  gap: 5px;
`

export const SearchContainer = styled.div`
  flex: 1;
  min-height: 0;
  gap: 5px;

  display: flex;
  flex-direction: column;

  overflow-y: auto;
`

export const SearchCard = styled.div<{ transferred: boolean }>`
  cursor: pointer;

  display: flex;
  flex-direction: column;
  justify-content: center;

  padding: 5px;

  height: 60px;

  color: black;

  border: 2px solid ${(props) => props.theme.colors.primaryBlue};
  border-left: 10px solid ${(props) => props.theme.colors.primaryBlue};

  h3 {
    font-size: 1.1rem;
    color: ${(props) => (props.transferred ? "red" : "black")};
  }

  @media (max-width: 768px) {
    p {
      font-size: 12px;
    }
  }
`

export const FieldsContainer = styled.span`
  display: flex;
  flex-direction: row;

  gap: 5px;

  span {
    display: flex;
    flex-direction: row;

    gap: 5px;
  }

  @media (max-width: 768px) {
    flex-direction: column;
  }
`

export const GradesContainer = styled.div`
  display: flex;
  flex-direction: column;

  height: 100vh;
  overflow: hidden;

  margin: 15px;
  gap: 8px;

  h2 {
    align-self: flex-end;
  }
`

export const TestsWrapper = styled.div`
  flex: 1;
  min-height: 0;
  overflow-y: auto;
`

export const TestsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const TestsCard = styled.div`
  cursor: pointer;
  overflow: hidden;

  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  padding: 5px;

  height: 75px;

  color: black;

  border: 2px solid ${(props) => props.theme.colors.primaryBlue};
  border-left: 10px solid ${(props) => props.theme.colors.primaryBlue};

  h3 {
    font-size: 1.2rem;

    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;

    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }

  p {
    color: ${(props) => props.theme.colors.primaryBlue};
    font-size: 1.2rem;
    @media (max-width: 768px) {
      font-size: 0.9rem;
    }
  }

  span:nth-child(2) {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 5px;

    label {
      color: ${(props) => props.theme.colors.text};
      font-size: 1.2rem;

      @media (max-width: 768px) {
        font-size: 0.9rem;
      }
    }

    input {
      width: 150px;
      height: 40px;

      text-align: center;
      padding: 8px;

      border: 0;
      background: transparent;
      color: #5b5b5b;
      border-radius: 8px;
      border: 2px solid ${(props) => props.theme.colors.primaryBlue};

      &::placeholder {
        color: #5b5b5b;
      }

      @media (max-width: 768px) {
        width: 75px;
      }

      &:disabled {
        background-color: #d3d3d3;
      }
    }

    button {
      display: flex;
      align-items: center;
      justify-content: center;

      border: 1px solid green;
      border-radius: 8px;
      color: white;
      background-color: green;

      width: 40px;
      height: 40px;

      &.reset {
        border: 1px solid #d21404;
        background-color: #d21404;
      }

      svg {
        width: 20px;
        height: 20px;
      }
    }
  }
`

export const AbsencesContainer = styled.div`
  display: flex;
  flex-direction: column;

  margin: 15px;
`

export const Table = styled.table`
  margin-top: 10px;
`

export const TableHeader = styled.th`
  text-align: left;
  padding: 8px;
  border: 1px solid lightgray;
  //background-color: ${(props) => props.theme.colors.secondaryBlue};
`

export const TableData = styled.td`
  padding: 8px;
  border: 1px solid lightgray;
`
